import { Injectable } from '@angular/core';
import { LocalStorageWrapper } from '../classes/local-storage-wrapper.class';

@Injectable()
export class FormatService {
    constructor() {}

    private get locale(): string {
        let language: string = LocalStorageWrapper.getLocale();
        return language === 'hu' ? 'hu-HU' : 'en-GB';
    }

    public formatDateOnly(date: Date): string {
        return new Intl.DateTimeFormat(this.locale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).format(date);
    }

    public formatDateTime(date: Date): string {
        return new Intl.DateTimeFormat(this.locale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        }).format(date);
    }

    public formatCurrency(data: number): string {
        let language: string = LocalStorageWrapper.getLocale();
        let currency = language === 'hu' ? 'HUF' : 'EUR';

        return new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: currency,
            maximumFractionDigits: currency === 'HUF' ? 0 : 2,
        }).format(data);
    }
}
